module.exports = __webpack_public_path__ + "static/img/default.5731fc51.jpg";